import React from 'react';
import { Mutation } from 'react-apollo';
import Propagator from '../../Propagator';
import gql from 'graphql-tag';

const SET_VARIABLE = gql`
	mutation($gameID: ID!, $submission: Int!, $name: String!, $year: Int! $value: FloatOrString!) {
		setVariable( gameID: $gameID, submission: $submission, name: $name, year: $year, value: $value) @client{
			id
			data
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={SET_VARIABLE}>
		{setVariable => Propagator(children, setVariable)}
	</Mutation>
);
